// extracted by mini-css-extract-plugin
module.exports = {"tool":"AppCard_tool__4VpJd","wrap":"AppCard_wrap__1wk1b","title":"AppCard_title__3A7gG"};